import React from 'react';
import { RefreshCw } from 'lucide-react';

const LoadMoreButton = ({ onClick, loading, hasMore }) => {
  if (!hasMore) {
    return (
      <div className="text-center py-6">
        <p className="text-[10px] text-gray-400">没有更多记录了</p>
      </div>
    );
  }

  return (
    <div className="mt-4 text-center pb-6">
      <button
        onClick={onClick}
        disabled={loading}
        className={`text-xs font-bold py-1.5 px-6 rounded-lg transition-all ${
          loading 
          ? 'text-gray-400 bg-gray-50 flex items-center gap-2 mx-auto cursor-not-allowed' 
          : 'text-blue-600 hover:bg-blue-50 bg-white border border-blue-100 shadow-sm active:scale-95'
        }`}
      >
        {loading ? (
          <>
            <RefreshCw size={12} className="animate-spin" />
            加载中...
          </>
        ) : (
          '加载更多'
        )}
      </button>
    </div>
  );
};

export default LoadMoreButton;
